<template>
  <!-- 一对一咨询表单页 -->
  <div class="otocouform">
    <div class="bgf8">
      <div class="w12 form">
        <div class="formheder flex_start">
          <div class="usercove">
            <img src="../../assets/case/aaaa1_sample.png" alt="" />
          </div>
          <div class="userin">
            <div class="username">王世方律师团队</div>
            <div class="serviceadr">服务地区：<span>安徽</span> 当事人</div>
          </div>
        </div>
        <div class="forminput">
          <textarea
            class="textarea"
            placeholder="请在此详细描述问题，律师依据详情为您提供专业解答。"
            v-model="otoformtext"
            maxlength="800"
            @keyup.enter="submit"
          ></textarea>
          <div class="srin between">
            <div class="curadr">
              <img src="../../assets/case/bluedingwei.png" />
              <span>安徽</span>
              <span>合肥</span>
            </div>
            <div class="sum">{{ textlength }}/800</div>
          </div>
        </div>
        <div class="submitzx">提交咨询</div>
      </div>
    </div>
    <div>
      <div class="w12 pd5 between">
        <div class="lcitem flex_start">
          <div class="lciticon">
            <img src="../../assets/case/otoformicon1.png" alt="" />
          </div>
          <div class="lcittxt">
            <div class="txt1">提交咨询</div>
            <div class="txt2">详细描述问题</div>
          </div>
        </div>

        <div class="lcitem flex_start">
          <div class="lciticon">
            <img src="../../assets/case/otoformicon2.png" alt="" />
          </div>
          <div class="lcittxt">
            <div class="txt1">律师解答</div>
            <div class="txt2">约3～15分钟</div>
          </div>
        </div>

        <div class="lcitem flex_start">
          <div class="lciticon">
            <img src="../../assets/case/otoformicon3.png" alt="" />
          </div>
          <div class="lcittxt">
            <div class="txt1">短信提醒</div>
            <div class="txt2">收到律师解答</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      otoformtext: "",
    };
  },
  computed: {
    textlength() {
      return this.otoformtext.split("").length;
    },
  },
};
</script>

<style lang="scss" scoped>
.otocouform {
  background: #ffffff;
  .bgf8 {
    background: #f8f8f8;
  }
  .w12 {
    width: 750px;
  }
  .form {
    margin: 50px auto 0;
    padding: 35px 0;
    .formheder {
      width: 100%;
      .usercove {
        margin-right: 10px;
        img {
          width: 64px;
          height: 64px;
          border-radius: 50%;
        }
      }
      .userin {
        .username {
          font-size: 22px;
          line-height: 22px;
          color: #333333;
        }
        .serviceadr {
          margin-top: 10px;
          font-size: 16px;
          color: #999999;
          span {
            color: #0465ea;
          }
        }
      }
    }
    .forminput {
      width: 100%;
      height: 254px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(1, 1, 1, 0.08);
      border-radius: 10px;
      overflow: hidden;
      padding: 20px 30px;
      margin-top: 36px;
      .textarea {
        line-height: 24px;
        font-size: 14px;
        outline: none;
        border: none;
        width: 100%;
        height: 194px;
        &::placeholder {
          color: #d1d1d1;
        }
      }
      .srin {
        .curadr {
          img {
            width: 10px;
            height: 14px;
            margin-right: 10px;
          }
          span {
            margin-right: 10px;
            font-size: 14px;
            color: #488cef;
          }
        }
        .sum {
          font-size: 14px;
          color: #d1d1d1;
          margin-right: 8px;
        }
      }
    }

    .submitzx {
      width: 200px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      margin: 35px auto 0;
      background: linear-gradient(-90deg, #015eea 8%, #458fff 100%);
      border-radius: 5px;
      font-size: 18px;
      color: #ffffff;
    }
  }
  .pd5 {
    padding: 50px 0;
    margin: 0 auto;
    .lcitem {
      .lciticon {
        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
      }
      .lcittxt {
        margin-left: 20px;
        .txt1 {
          font-size: 18px;
          color: #666666;
          line-height: 18px;
        }
        .txt2 {
          margin-top: 6px;
          font-size: 14px;
          color: #999999;
        }
      }
    }
  }
}
</style>